module.exports = __webpack_public_path__ + "img/job-heavy-manual.e8cbc54c.svg";